/**
 *
 * IMPORTANT NOTICE
 *
 * This file contains the **common logic** for the **Transact Payment Page**.
 *
 * - It is shared between both Vue 2 and Vue 3 applications.
 * - **Vue-specific syntax** (Vue 2 or Vue 3) must not be used in this file.
 * - The use of the **store concept** is strictly prohibited in this file.
 *
 * For more details, please contact **Leela**.
 *
 */

import Axios from 'axios';
import {
  EXPRESS_SECTION_CREDIT_SCORE_BOX,
  EXPRESS_SECTION_INCENTIVES_BOX,
  EXPRESS_SECTION_PAYMENT_BOX,
  EXPRESS_SECTION_SCHEDULE_DELIVERY_BOX,
  EXPRESS_SECTION_SERVICE_PROTECTION_BOX,
  EXPRESS_SECTION_TAXES_BOX,
  EXPRESS_SECTION_TRADE_VALUES_BOX,
} from '../../constants/expresspaymentconstants';

export function getEnabledStepsInTransact(selectedPaymentSettings, incentivesData) {
  console.log('Transact Common Utility enabled Steps');
  let enabledTransactSections = [];
  enabledTransactSections.push(EXPRESS_SECTION_PAYMENT_BOX);

  if (selectedPaymentSettings?.showIncentives) {
    if (incentivesData?.length) {
      enabledTransactSections.push(EXPRESS_SECTION_INCENTIVES_BOX);
    }
  }
  if (selectedPaymentSettings?.showTradeIn) {
    enabledTransactSections.push(EXPRESS_SECTION_TRADE_VALUES_BOX);
  }
  if (selectedPaymentSettings?.showCreditScore) {
    enabledTransactSections.push(EXPRESS_SECTION_CREDIT_SCORE_BOX);
  }
  if (selectedPaymentSettings?.showTaxesAndFees) {
    enabledTransactSections.push(EXPRESS_SECTION_TAXES_BOX);
  }

  if (selectedPaymentSettings?.showServiceAndProtectionPlans) {
    enabledTransactSections.push(EXPRESS_SECTION_SERVICE_PROTECTION_BOX);
  }

  enabledTransactSections.push(EXPRESS_SECTION_SCHEDULE_DELIVERY_BOX);

  return enabledTransactSections;
}

export async function fetchRegionsFromApi(zipCode) {
  console.log('Fetching Regions with zipcode from API');
  let response = await Axios.get(
    `${atob(window.portalUrl)}/offermanager/Service/PaymentAPI/GetRegions?zipcode=${zipCode}`
  );
  return response;
}
